import { toLongHexColor } from '@repo/toolkit/colors'
import Typography from '@repo/ui/typography'
import { useState } from 'react'
import { HexColorInput, HexColorPicker } from 'react-colorful'

import { useFormField } from '../forms/form'

type Props = {
  label: string
  value?: string | null
  onChange: (value: string) => void
}

// rendered inside the page (no native colour dialog), so using it never dismisses the modal around it
const ControlledColorInput: React.FC<Props> = ({ label, value, onChange }) => {
  const { error } = useFormField()
  const [isPickerOpen, setIsPickerOpen] = useState(false)
  const color = value ?? '#000000'

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-2">
        <Typography variant="label" className="text-[9px] text-grey">
          {label}
        </Typography>
        <button
          type="button"
          aria-label={label}
          className="w-24 h-6 rounded border border-grey-light cursor-pointer"
          style={{ backgroundColor: color }}
          onClick={() => setIsPickerOpen((open) => !open)}
        />
        <HexColorInput
          prefixed
          color={color}
          // the short form (#abc) is only expanded on blur, expanding it while typing would rewrite the text
          onChange={(hex) => {
            if (hex.length === 7) onChange(toLongHexColor(hex))
          }}
          onBlur={(event) => {
            if (event.target.value.length === 4) onChange(toLongHexColor(event.target.value))
          }}
          aria-label={`${label} (hex)`}
          className="w-24 px-2 py-1 rounded border border-grey-light text-sm uppercase"
        />
      </div>
      {isPickerOpen && <HexColorPicker color={color} onChange={onChange} />}
      {error && (
        <Typography variant="label" className="text-red">
          {String(error.message)}
        </Typography>
      )}
    </div>
  )
}

export default ControlledColorInput
